<script setup>
const props = defineProps({
  alertActive: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Alert'
  },
  confirmText: {
    type: String,
    default: 'OK'
  },
  cancelText: {
    type: String,
    default: 'Cancel'
  },
  showCancelButton: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['closeAlert', 'confirmAlert'])

const closeAlert = (e) => {
  e.stopPropagation()
  emit('closeAlert')
}

const clickOnAlert = (e) => {
  e.stopPropagation()
}

const confirmAlert = (e) => {
  e.stopPropagation();
  emit('confirmAlert');
}
</script>

<template>
  <transition name="alert-dialog-animation">
    <div v-show="alertActive" class="alert-dialog" @click="clickOnAlert">
      <transition name="alert-dialog-animation-inner">
        <div v-show="alertActive" class="alert-dialog-inner">
          <div class="header">
            {{ title }}
          </div>
          <div class="content">
            <slot />
          </div>
          <div class="button-container">
            <button :disabled="disabled" @click="confirmAlert">
              {{ confirmText }}
            </button>
            <button v-if="showCancelButton" class="cancel-button" @click="closeAlert">
              {{ cancelText }}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>